import React, { useState, useEffect } from 'react';
import axios from 'axios';

import ProjectSummary from './ProjectSummary';
import ProjectRoleSummary from './ProjectRoleSummary';
import ProjectsVsTime from './ProjectsVsTime';

const ProjectsDashboard = () => {
  const [projectLoading, setProjectLoading] = useState(false);
  const [projectStats, setProjectStats] = useState({});

  useEffect(() => {
    const getProjectStats = async () => {
      setProjectLoading(true);
      setProjectStats({});
      try {
        const response = await axios({
          method: 'GET',
          url: '/api/v1/admin/getProjectStats',
        });
        setProjectStats(response.data.data);
      } catch (err) {
        console.log('Error->', err.response.data.message);
      }
      setProjectLoading(false);
    };
    getProjectStats();
  }, []);

  return (
    <div className="adminDashboard">
      <h1>Projects Dashboard</h1>
      <div className="adminDashboardContainer">
        <div className="flex">
          <ProjectSummary loading={projectLoading} stats={projectStats} />
          <ProjectRoleSummary loading={projectLoading} stats={projectStats} />
        </div>
        <div className="flex">
          <ProjectsVsTime />
        </div>
      </div>
    </div>
  );
};

export default ProjectsDashboard;
